import React from "react"

const Buttons = () => (
    <div className="buttons">
        <a className="btn" href="https://drive.google.com/file/d/1bVJgmMCPU0NHKX2yRFDAL3Sciqtcvwck/view">My Resume</a>
        <a className="btn" href="mailto:deguzmanbrianfrancis@gmail.com">Contact Me</a>
    </div>
)

export default Buttons